import { INVOICE_REPORT_SUMMARY_QUERY_KEY } from '@/features/invoice_reports/constants';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useInvalidateInvoiceReportDrawer = (selectedId: string | null) => {
  const queryClient = useQueryClient();

  const invalidateDrawerIfOpen = useCallback(
    (reportId: string) => {
      if (selectedId === reportId) {
        queryClient.invalidateQueries({
          queryKey: [INVOICE_REPORT_SUMMARY_QUERY_KEY, reportId],
        });
      }
    },
    [selectedId, queryClient]
  );

  return { invalidateDrawerIfOpen };
};
